import { initReactI18next } from "react-i18next";
import i18n, { InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import { assetsPaths } from "utils/url.utils";
import { DEFAULT_LANG } from "../constants/common.constants";

const i18nextOptions: InitOptions = {
  debug: false,
  backend: {
    backends: [HttpBackend],
    backendOptions: [
      {
        loadPath: assetsPaths.locales.translationFileBuilder().build(),
      },
    ],
  },
  initImmediate: false,
  fallbackLng: DEFAULT_LANG,
  lng: DEFAULT_LANG,
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
};

i18n.use(LanguageDetector).use(initReactI18next).use(ChainedBackend).init(i18nextOptions);

export { i18n };
